import { SvgIcon, SvgIconProps } from "@commonlibs";
import clsx from "clsx";

export default function ExchangeIcon({ className, ...rest }: Omit<SvgIconProps, "children">): JSX.Element {
    return (
        <SvgIcon {...rest} data-testid="ExchangeIcon" className={clsx(undefined, "Icon", className)} fill="none">
            <path
                id="FontAwsome_exchange-alt_"
                d="M0,59.863v-.555a.833.833,0,0,1,.833-.833H13.325V56.81a.833.833,0,0,1,1.422-.589L17.523,59a.833.833,0,0,1,0,1.178l-2.776,2.776a.833.833,0,0,1-1.422-.589V60.7H.833A.833.833,0,0,1,0,59.863Zm16.934,5.275H4.442V63.472a.833.833,0,0,0-1.422-.589L.244,65.659a.833.833,0,0,0,0,1.178L3.02,69.613a.833.833,0,0,0,1.422-.589V67.359H16.934a.833.833,0,0,0,.833-.833v-.555A.833.833,0,0,0,16.934,65.138Z"
                transform="translate(0.581 -55.46)"
                fill="none"
                stroke="#fff"
                strokeWidth="1"
            />
        </SvgIcon>
    );
}
